import apiClient from '../config/axiosConfig';
import { handleError } from '../errors/handleError';
import * as types from './actionTypes';
import { addAlert } from './alertActions';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);
    dispatch({
        type,
        error: errorMessage,
    });
    let messageResp;
    if (error.data && error.data.errorMessages && error.data.errorMessages.length > 0) {
        messageResp = error.data.errorMessages[0];
    } else {
        messageResp = errorMessage;
    }
    dispatch(addAlert({
        message: messageResp,
        view: '/messages',
        type: 'banner',
        dismissable: true,
        id: 'message-api',
    }));
}

export function getMessages(limit, offset, orgId, sinceTime, beforeTime, timeAscending) {
    return function (dispatch) {
        dispatch({
            type: types.GET_MESSAGES_PENDING,
        });
        return apiClient.get(`/v2/message?limit=${limit}&offset=${offset}&orgId=${orgId}&sinceTime=${sinceTime}&beforeTime=${beforeTime}&timeAscending=${timeAscending}&showAll=true`)
            .then((response) => {
                if (sinceTime === 0) {
                    dispatch({
                        type: types.GET_MESSAGES_TOTAL,
                        payload: response.data.data.noOfMessages,
                    });
                }
                dispatch({
                    type: types.GET_MESSAGES_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_MESSAGES_FAILED);
            });
    };
}

export function getMessagesTotal(orgId) {
    return function (dispatch) {
        return apiClient.get(`/v2/message/count?orgId=${orgId}`)
            .then((response) => {
                dispatch({
                    type: types.GET_MESSAGES_TOTAL,
                    payload: response.data.data.noOfMessages,
                });
            })
            .catch(() => {
            });
    };
}
export function deleteMessage(messageId, pageInfo) {
    return function (dispatch) {
        dispatch({
            type: types.DELETE_MESSAGE_PENDING,
        });
        return apiClient.delete(`/v2/message/${messageId}`)
            .then((response) => {
                return Promise.all([dispatch({
                    type: types.DELETE_MESSAGE_SUCCESS,
                    payload: response.data.data,
                }),
                dispatch(
                    getMessages(
                        pageInfo.limit,
                        pageInfo.offset,
                        pageInfo.orgId,
                        pageInfo.sinceTime,
                        pageInfo.beforeTime,
                        pageInfo.timeAscending,
                    ),
                ),
                ]);
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.DELETE_MESSAGE_FAILED);
            });
    };
}

export function updateMessage(messageId, subject, body, scheduledTime, pageInfo, formMessage, formId, formTitle) {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MESSAGE_PENDING,
        });
        return apiClient.put(`/v2/message/${messageId}`, {
            subject,
            body,
            scheduledTime,
            formMessage,
            formId,
            formTitle,
        })
            .then((response) => {
                return Promise.all([dispatch({
                    type: types.UPDATE_MESSAGE_SUCCESS,
                    payload: response.data.data,
                }),
                dispatch(
                    getMessages(
                        pageInfo.limit,
                        pageInfo.offset,
                        pageInfo.orgId,
                        pageInfo.sinceTime,
                        pageInfo.beforeTime,
                        pageInfo.timeAscending,
                    ),
                ),
                ]);
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.UPDATE_MESSAGE_FAILED);
            });
    };
}

export function getMessage(messageId) {
    return function (dispatch) {
        dispatch({
            type: types.GET_MESSAGE_PENDING,
        });
        return apiClient.get(`/v2/message/${messageId}`)
            .then((response) => {
                dispatch({
                    type: types.GET_MESSAGE_SUCCESS,
                    payload: response.data.data,
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_MESSAGE_FAILED);
            });
    };
}

export function createMessage(subject, body, scheduledTime, pageInfo, formMessage, formId, formTitle) {
    return function (dispatch) {
        dispatch({
            type: types.CREATE_MESSAGE_PENDING,
        });
        return apiClient.put('/v2/message/create', {
            subject,
            body,
            scheduledTime,
            formMessage,
            formId,
            formTitle,
        })
            .then((response) => {
                return Promise.all([dispatch({
                    type: types.CREATE_MESSAGE_SUCCESS,
                    payload: response.data.data,
                }),
                dispatch(
                    getMessages(
                        pageInfo.limit,
                        pageInfo.offset,
                        pageInfo.orgId,
                        pageInfo.sinceTime,
                        pageInfo.beforeTime,
                        pageInfo.timeAscending,
                    ),
                ),
                dispatch(getMessagesTotal(pageInfo.orgId)),
                ]);
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.CREATE_MESSAGE_FAILED);
            });
    };
}
